module.exports = "/components/components/collapseToggleComponent-1ab131.html";